// import Styles from '../plugins/styles/styles';
import '@fortawesome/fontawesome-free/css/all.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

import fr from 'vuetify/es5/locale/fr';

const fontSettings = {
  icons: {
    iconfont: 'md',
  },
};

const themeSettings = {
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#110D8C',
        secondary: '#1DB89C',
        accent: '#F6C224',
        error: 'EA473E',
      },
      dark: {
        accent: '#F6C224',
        error: 'EA473E',
      },
    },
  },
};

const langSettings = {
  lang: {
    locales: {
      fr,
    },
    current: 'fr',
  },
};

let vuetifySettings = {};
Object.assign(vuetifySettings, fontSettings);
Object.assign(vuetifySettings, themeSettings);
Object.assign(vuetifySettings, langSettings);

Vue.use(Vuetify);
export default new Vuetify(vuetifySettings);
